import React, {Component} from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Nav,
  NavItem, NavLink,
  TabContent, TabPane
} from 'reactstrap';
import {toast, ToastContainer} from 'react-toastify';
import {getData} from '../../api/doLogin.js';
import {postData} from "../../api/doLogin";
import {BasicInfo} from './sections/BasicInfo';
import {PrimaryInfo} from './sections/PrimaryInfo';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './react_dates_overrides.css';
import '../../../scss/vendors/react-select/react-select.scss';
import classnames from 'classnames';
import {traversePropertiesArray, traversePropertiesString} from "./shared/shared";
import {ApplicationData} from "./shared/applicationConverter";
import {SpouseInfo} from "./sections/SpouseInfo";
import {DependentsInfo} from "./sections/DependentsInfo";
import {Coverages} from "./sections/Coverages";
import {HealthInfo} from "./sections/HealthInfo";
import {BeneficiaryInfo} from "./sections/BeneficiaryInfo";
import {PaymentInfo} from "./sections/PaymentInfo";
import {AgentInfo} from "./sections/AgentInfo";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

class ApplicationForm extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);

    this.state = {
      data: [],
      cities: [],
      dataLoaded: false,
      formFields: {},
      windowWidth: window.innerWidth,
      orientation: 'vertical',
      openDirection: 'down',
      selectedDisciplines: [],
      serverDisciplines: [],
      readonly: false,
      activeTab: '1',
      formValidated: false,
      formValidatedText: "",
      agentData: []
    };
    this.disciplines = [
      {value: "Newspaper", label: "Newspaper"},
      {value: "Text", label: "Text"},
      {value: "Email", label: "Email"},
      {value: "Phone Call", label: "Phone Call"},
      {value: "Existing Client", label: "Existing Client"},
      {value: "Friend/Coworker", label: "Friend/Coworker"},
      {value: "Road Signs", label: "Road Signs"},
      {value: "On Base/Post Event", label: "On Base/Post Event"},
      {value: "Billboard", label: "Billboard"},
      {value: "Mailer", label: "Mailer"}
    ];

  }

  getFormFieldValue(val) {
    if (val != null) {
      return val;
    } else {
      return "";
    }
  }

  setFormFieldValue(field, value) {
    if (this.state.readonly) return;
    var objPost = {}
    if (field === "signature") {
      if (value.length > 0) {
        objPost = {
          ...this.state.formFields,
          [field]: value,
          datesigned: new Date().toDateString()
        }
      } else {
        objPost = {
          ...this.state.formFields,
          [field]: value,
          datesigned: ""
        }
      }

    } else if (field === "spsignature") {
      if (value.length > 0) {
        objPost = {
          ...this.state.formFields,
          [field]: value,
          spdatesigned: new Date().toDateString()
        }
      } else {
        objPost = {
          ...this.state.formFields,
          [field]: value,
          spdatesigned: ""
        }
      }

    } else {
      objPost = {
        ...this.state.formFields,
        [field]: value,
      }
    }
    this.setState({
      formFields: objPost,
    });

  }

  componentDidMount() {
    console.log(this.props);
    this.updateData();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.type !== this.props.match.params.type || prevProps.action !== this.props.action || prevProps.match.params.id !== this.props.match.params.id) {
      this.updateData();
    }

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions() {
    const windowWidth = window.innerWidth;
    this.setState((state) => {
      return ({
        windowWidth: windowWidth,
        orientation: windowWidth < 620 ? 'vertical' : 'horizontal',
        openDirection: windowWidth < 620 ? 'up' : 'down'
      });
    });
  }

  updateData() {
    const self = this;
    if (this.props.action === "add") {
      getData("applications/agentdata", {}, this.props.token)
        .then((data) => {
          if (data.status === "Success") {
            console.log(data.data);
            self.setState({dataLoaded: true, formFields: {}, agentData: data.data.agentdata});
          }
        })
        .catch(error => {
          console.error(error)
        });

    } else {
      getData("applications/get?id=" + this.props.match.params.id, {}, this.props.token)
        .then((data) => {
          if (data.status === "Success") {
            console.log(data.data);
            self.setState({
              data: data.data.application,
              dataLoaded: true,
              formFields: (this.props.action === "edit" ? data.data.application.data : {}),
              readonly: data.data.application.status !== "new",
              agentData: data.data.agentdata
            });
          }
        })
        .catch(error => {
          console.error(error)
        });
    }
  }

  onCloseClick() {
    this.props.history.push("/applications");
  }

  onClickSave(type) {
    //Validation checks here
    const postObj = {
      action: this.props.action,
      type: type,
      formData: this.state.formFields,
      display: this.getDisplayName(),
      id: this.props.match.params.id || "",
    };
    let postIt = ApplicationData().convert(postObj);
    console.log(postObj.formData);
    console.log(postIt.data)
    if (postIt.status === "Success") {
      postObj['applicationData'] = postIt.data;
    }
    if (postIt.status === "Error" && type === "submit") {
      this.setState({formValidatedText: postIt.data, formValidated: false});
      return;
    }
    var self = this;
    postData("applications/save", postObj, this.props.token)
      .then((data) => {
        if (data.status === "Success") {

          if (postIt.status === "Error") {
            self.setState({formValidatedText: postIt.data, formValidated: false});
          } else {
            self.setState({
              formValidatedText: "Congrats! Your application meets the criteria for submission",
              formValidated: true
            });
          }
          if (self.props.action === "add") {
            toast.success('Application Progress Saved.' + (this.state.formValidated ? "Click the green submit button." : ""));
            setTimeout(() => {
              self.props.history.push("/applications/edit_" + data.data.id);
            }, 1000);
          } else {
            if (type === "submit") {
              toast.info('Application Saved and Submission in Progress...');
              self.setState({readonly: true});
              setTimeout(() => {
                self.props.history.push("/applications/submit_" + this.props.match.params.id);
              }, 1000);
            } else {
              toast.success('Application Progress Saved.' + (this.state.formValidated ? "Click the green submit button." : ""));
            }
          }
        } else {
          toast.error("Error " + data.message);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  getDisplayName() {
    let strResponse = "New Applicant";
    const primaryObject = traversePropertiesArray(this.state.formFields, ['primary']);
    if (primaryObject.hasOwnProperty("fname") || primaryObject.hasOwnProperty("lname")) {
      let tResponse = [this.getFormFieldValue(primaryObject.fname), this.getFormFieldValue(primaryObject.lname)].join(" ").trim();
      if (tResponse.length > 0) strResponse = tResponse;
    }
    const hasSpouse = traversePropertiesArray(this.state.formFields, ['basic', 'relationshipStatus']) === "M";
    const hasDependents = traversePropertiesArray(this.state.formFields, ['dependents']).length > 0;
    if (hasSpouse || hasDependents) {
      strResponse = strResponse + (" Family");
    }
    return strResponse;
  }

  render() {
    const containerStyle = {
      zIndex: 1999
    };

    return (
      <div className="animated fadeIn">
        <ToastContainer position="bottom-right" autoClose={5000} style={containerStyle}/>
        {this.state.dataLoaded && (
          <Card>
            <CardHeader>
              Application
              Form {this.getFormFieldValue(this.state.formFields.year).length > 0 ? " for Tax Year " + this.getFormFieldValue(this.state.formFields.year) : ""}

              <div className="card-actions">
                {!this.state.readonly && (
                  <button onClick={() => this.onClickSave("save")}>
                    <small className="text-muted">Save</small>
                  </button>
                )}
                <button onClick={() => this.onCloseClick()}>
                  <small className="text-muted">Close</small>
                </button>
              </div>
            </CardHeader>
            <CardBody>
              <div style={{textAlign: 'right'}}>Click the 'Save Button' above to save progress and pre-audit.</div>
              <div align="right">
                <span
                  style={{color: (this.state.formValidated ? brandSuccess : brandDanger)}}>{this.state.formValidatedText}</span>&nbsp;
                <Button color="success" disabled={!this.state.formValidated}
                        onClick={(evt) => this.onClickSave("submit")}>Submit Application Now</Button>
              </div>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === '1'})}
                    onClick={() => this.toggle('1')}>
                    Basic Info
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === '2'})}
                    onClick={() => this.toggle('2')}>
                    Primary Info
                  </NavLink>
                </NavItem>
                {this.getFormFieldValue(traversePropertiesString(this.state.formFields, ['basic', 'relationshipStatus'])) === "M" && (
                  <NavItem>
                    <NavLink
                      className={classnames({active: this.state.activeTab === '3'})}
                      onClick={() => this.toggle('3')}>
                      Spouse Info
                    </NavLink>
                  </NavItem>
                )}
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === '4'})}
                    onClick={() => this.toggle('4')}>
                    Dependent{this.getFormFieldValue(traversePropertiesString(this.state.formFields, ['basic', 'relationshipStatus'])) === "M" ? "s" : ""}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === '5'})}
                    onClick={() => this.toggle('5')}>
                    Coverage{this.getFormFieldValue(traversePropertiesString(this.state.formFields, ['basic', 'relationshipStatus'])) === "M" ? "s" : ""}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === '6'})}
                    onClick={() => this.toggle('6')}>
                    {this.getFormFieldValue(traversePropertiesString(this.state.formFields, ['basic', 'relationshipStatus'])) === "M" ? "Primary " : ""}Health
                  </NavLink>
                </NavItem>
                {this.getFormFieldValue(traversePropertiesString(this.state.formFields, ['basic', 'relationshipStatus'])) === "M" && (
                  <NavItem>
                    <NavLink
                      className={classnames({active: this.state.activeTab === '7'})}
                      onClick={() => this.toggle('7')}>
                      Spouse Health
                    </NavLink>
                  </NavItem>
                )}
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === '8'})}
                    onClick={() => this.toggle('8')}>
                    Beneficiar{this.getFormFieldValue(traversePropertiesString(this.state.formFields, ['basic', 'relationshipStatus'])) === "M" ? "ies" : "y"}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === '9'})}
                    onClick={() => this.toggle('9')}>
                    Payment
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({active: this.state.activeTab === '10'})}
                    onClick={() => this.toggle('10')}>
                    Agent
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="1">
                  <BasicInfo values={this.state.formFields.basic || {}}
                             handleCB={(resp) => this.setFormFieldValue('basic', resp)} readonly={this.state.readonly}
                             formFields={this.state.formFields}/>
                </TabPane>
                <TabPane tabId="2">
                  <PrimaryInfo values={this.state.formFields.primary || {}}
                               handleCB={(resp) => this.setFormFieldValue('primary', resp)}
                               readonly={this.state.readonly} formFields={this.state.formFields}/>
                </TabPane>
                <TabPane tabId="3">
                  <SpouseInfo values={this.state.formFields.spouse || {}}
                              handleCB={(resp) => this.setFormFieldValue('spouse', resp)} readonly={this.state.readonly}
                              formFields={this.state.formFields}/>
                </TabPane>
                <TabPane tabId="4">
                  <DependentsInfo values={this.state.formFields.dependents || []}
                                  handleCB={(resp) => this.setFormFieldValue('dependents', resp)}
                                  readonly={this.state.readonly} formFields={this.state.formFields}/>
                </TabPane>
                <TabPane tabId="5">
                  <Coverages values={this.state.formFields.coverages || []}
                             handleCB={(resp) => this.setFormFieldValue('coverages', resp)}
                             readonly={this.state.readonly} formFields={this.state.formFields}/>
                </TabPane>
                <TabPane tabId="6">
                  <HealthInfo values={this.state.formFields.health || []}
                              handleCB={(resp) => this.setFormFieldValue('health', resp)} readonly={this.state.readonly}
                              formFields={this.state.formFields}
                              gender={traversePropertiesString(this.state.formFields, ['primary', 'gender'])}/>
                </TabPane>
                <TabPane tabId="7">
                  <HealthInfo values={this.state.formFields.spouseHealth || []}
                              handleCB={(resp) => this.setFormFieldValue('spouseHealth', resp)}
                              readonly={this.state.readonly} formFields={this.state.formFields}
                              gender={traversePropertiesString(this.state.formFields, ['spouse', 'gender'])}/>
                </TabPane>
                <TabPane tabId="8">
                  <BeneficiaryInfo values={this.state.formFields.beneficiary || []}
                                   handleCB={(resp) => this.setFormFieldValue('beneficiary', resp)}
                                   readonly={this.state.readonly} formFields={this.state.formFields}/>
                </TabPane>
                <TabPane tabId="9">
                  <PaymentInfo values={this.state.formFields.payment || {}}
                               handleCB={(resp) => this.setFormFieldValue('payment', resp)}
                               readonly={this.state.readonly} formFields={this.state.formFields}/>
                </TabPane>
                <TabPane tabId="10">
                  <AgentInfo values={this.state.formFields.agent || {}} agentdata={this.state.agentData}
                             handleCB={(resp) => this.setFormFieldValue('agent', resp)}
                             readonly={this.state.readonly} formFields={this.state.formFields}/>
                </TabPane>
                <span>&nbsp;* required field</span>
              </TabContent>

            </CardBody>
          </Card>
        )}
      </div>
    )
  }
}

export default ApplicationForm;



// WEBPACK FOOTER //
// ./src/containers/Applications/ApplicationForm.js